var pug = require("!../../../../../node_modules/.pnpm/pug@2.0.4/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (schemaI18n, value) {if (value) {
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = schemaI18n.enum('BidStrategyType', value)) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + (pug.escape(null == (pug_interp = ' ') ? "" : pug_interp));
}}.call(this,"schemaI18n" in locals_for_with?locals_for_with.schemaI18n:typeof schemaI18n!=="undefined"?schemaI18n:undefined,"value" in locals_for_with?locals_for_with.value:typeof value!=="undefined"?value:undefined));;return pug_html;};
module.exports = template;